import { ICssShadow } from './../ICssShadow.interface';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';
import { Video } from '../../../../../shared/sdk/index';

export class SeVideoConfig extends SeCommonConfig implements IBaseSEConfig {

  // settings just for this element
  public SeType = 'SeVideo';
  public modelRef: Video;
  public hlsSrc: string;
  public mute: boolean;
  public volume: number;
  public sourceUrl: string;
  public videoId: string;
  public loop: boolean;
  public poster = '';
  public autoplayInDesigner = false;

  public playList: Array<string> = new Array();

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }

  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.SeType = this.SeType;
    obj.mute = this.mute;
    obj.volume = this.volume;
    obj.modelRef = this.modelRef;
    obj.sourceUrl = this.sourceUrl;
    obj.videoId = this.videoId;
    obj.loop = this.loop;
    obj.poster = this.poster;
    obj.autoplayInDesigner = this.autoplayInDesigner;

    if (obj.modelRef) {
      this.files = [];
      this.files.push({
        libraryId: obj.modelRef.libraryId,
        fileName: obj.modelRef.ProcessedFilename,
        hash: obj.modelRef.hash
      });
      if (obj.poster) {
        const posterFilename = obj.poster.replace(/^.*[\\\/]/, '');
        this.files.push({
          libraryId: obj.modelRef.libraryId,
          fileName: posterFilename,
          hash: null
        });
      }
    }

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.mute = _.get(obj, 'mute', null);
    this.volume = _.get(obj, 'volume', .5);
    this.modelRef = _.get(obj, 'modelRef', null);
    this.sourceUrl = _.get(obj, 'sourceUrl', '');
    this.videoId = _.get(obj, 'videoId', '');
    this.loop = _.get(obj, 'loop', false);
    this.poster = _.get(obj, 'poster', '');
    this.autoplayInDesigner = _.get(obj, 'autoplayInDesigner', '');

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    if (this.modelRef) {
      this.files = [];
      this.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.ProcessedFilename,
        hash: this.modelRef.hash
      });

      if (obj.poster) {
        const posterFilename = obj.poster.replace(/^.*[\\\/]/, '');
        this.files.push({
          libraryId: obj.modelRef.libraryId,
          fileName: posterFilename,
          hash: null
        });
      }
    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-video/se-video-config.class.ts